import _DialogActions from "@mui/material/DialogActions";
import _Dialog from "@mui/material/Dialog";
import _Button from "@mui/material/Button";
import _DialogContent from "@mui/material/DialogContent";
import _FormControl from "@mui/material/FormControl";
import _FormControlLabel from "@mui/material/FormControlLabel";
import _Checkbox from "@mui/material/Checkbox";
import _Typography from "@mui/material/Typography";
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import { useFormik } from 'formik';
import { useSnackbar } from 'notistack';
import React, { useEffect } from 'react';
import { Trans, useTranslation } from 'react-i18next';
import { styled } from 'styled-components';
import image from '../../assets/images/newsletter.svg';
import { UserService } from '../../services';
export function NewsletterDialog({
  user,
  onClose,
  ...props
}) {
  const {
    t
  } = useTranslation();
  const {
    enqueueSnackbar
  } = useSnackbar();
  const {
    isSubmitting,
    values,
    setValues,
    handleChange,
    handleSubmit
  } = useFormik({
    initialValues: {
      receiveActivityEmails: false,
      receiveNewsletter: false
    },
    enableReinitialize: true,
    onSubmit
  });
  useEffect(() => {
    if (props.open) {
      const {
        options: {
          receiveEmails,
          receiveNewsletter
        }
      } = user;
      setValues({
        receiveActivityEmails: receiveEmails,
        receiveNewsletter
      });
    }
  }, [props.open]);
  async function onSubmit({
    receiveActivityEmails,
    receiveNewsletter
  }, {
    setSubmitting
  }) {
    setSubmitting(true);
    try {
      const options = await UserService.updateUserOptions(user.id, {
        receive_email: receiveActivityEmails,
        receive_newsletter: receiveNewsletter
      });
      onClose(options);
    } catch (err) {
      console.error(err);
      enqueueSnackbar(t('commons.newsletter_dialog.not_updated'));
    }
    setSubmitting(false);
  }
  return /*#__PURE__*/React.createElement(_Dialog, _extends({
    fullWidth: true,
    maxWidth: "sm",
    onClose: () => onClose(),
    scroll: "paper",
    slotProps: {
      paper: {
        sx: {
          borderRadius: 4
        }
      }
    }
  }, props), /*#__PURE__*/React.createElement("form", {
    onSubmit: handleSubmit
  }, /*#__PURE__*/React.createElement(_DialogContent, null, /*#__PURE__*/React.createElement(ContentWrapper, null, /*#__PURE__*/React.createElement(StyledLogo, {
    alt: "Logo newsletter",
    src: image
  })), /*#__PURE__*/React.createElement(_Typography, {
    gutterBottom: true,
    color: "primary",
    variant: "h5"
  }, /*#__PURE__*/React.createElement(Trans, {
    i18nKey: "commons.newsletter_dialog.title"
  })), /*#__PURE__*/React.createElement(StyledRow, null, /*#__PURE__*/React.createElement(_Typography, {
    color: "textSecondary",
    component: "p",
    variant: "caption"
  }, /*#__PURE__*/React.createElement(Trans, {
    i18nKey: "commons.newsletter_dialog.activity_emails_description"
  })), /*#__PURE__*/React.createElement(_FormControl, {
    component: "fieldset",
    disabled: isSubmitting
  }, /*#__PURE__*/React.createElement(_FormControlLabel, {
    control: /*#__PURE__*/React.createElement(_Checkbox, {
      color: "primary",
      name: "receiveActivityEmails",
      onChange: handleChange,
      value: values.receiveActivityEmails
    }),
    label: /*#__PURE__*/React.createElement(_Typography, {
      variant: "caption"
    }, /*#__PURE__*/React.createElement(Trans, {
      i18nKey: "commons.newsletter_dialog.receive_activity_emails"
    }))
  }))), /*#__PURE__*/React.createElement(StyledRow, null, /*#__PURE__*/React.createElement(_Typography, {
    color: "textSecondary",
    component: "p",
    variant: "caption"
  }, /*#__PURE__*/React.createElement(Trans, {
    i18nKey: "commons.newsletter_dialog.newsletter_description"
  })), /*#__PURE__*/React.createElement(_FormControl, {
    component: "fieldset",
    disabled: isSubmitting
  }, /*#__PURE__*/React.createElement(_FormControlLabel, {
    control: /*#__PURE__*/React.createElement(_Checkbox, {
      color: "primary",
      name: "receiveNewsletter",
      onChange: handleChange,
      value: values.receiveNewsletter
    }),
    label: /*#__PURE__*/React.createElement(_Typography, {
      variant: "caption"
    }, /*#__PURE__*/React.createElement(Trans, {
      i18nKey: "commons.newsletter_dialog.receive_newsletter"
    }))
  }))), /*#__PURE__*/React.createElement(StyledRow, null, /*#__PURE__*/React.createElement(_Typography, {
    color: "textSecondary",
    component: "p",
    variant: "caption"
  }, /*#__PURE__*/React.createElement(Trans, {
    i18nKey: "commons.newsletter_dialog.description"
  })))), /*#__PURE__*/React.createElement(StyledDialogActions, null, /*#__PURE__*/React.createElement(_Button, {
    disabled: isSubmitting,
    onClick: () => onClose(),
    size: "medium",
    type: "button"
  }, /*#__PURE__*/React.createElement(Trans, {
    i18nKey: "commons.actions.close"
  })), /*#__PURE__*/React.createElement(_Button, {
    color: "primary",
    disabled: isSubmitting,
    size: "medium",
    type: "submit",
    variant: "contained"
  }, /*#__PURE__*/React.createElement(Trans, {
    i18nKey: "commons.actions.confirm"
  })))));
}
const ContentWrapper = styled.div`
  display: flex;
  flex-direction: column;
  padding: 0 16px 16px;
`;
const StyledLogo = styled.img`
  align-self: center;
  margin: 16px 0;
  width: 120px;
`;
const StyledRow = styled.div`
  margin-top: 16px;
`;
const StyledDialogActions = styled(_DialogActions)`
  justify-content: flex-end;
`;